import { Component, input, output, OnChanges, SimpleChanges, computed, signal } from "@angular/core";
import { PageInfo } from "../../../gql/generated";
import { MatSortModule, Sort } from "@angular/material/sort";
import { TranslateModule } from "@ngx-translate/core";
import { PaginationComponent } from "../../common/pagination/pagination";
import { CommonModule } from "@angular/common";

@Component({
  selector: "cert-dns-firewall-table",
  templateUrl: "cert-dns-firewall-table.html",
  styleUrls: ["cert-dns-firewall-table.scss"],
  imports: [CommonModule, MatSortModule, PaginationComponent, TranslateModule],
})
export class CertDNSFirewallTableComponent {
  protected dnsFirewallLogs = input.required<any>();
  protected pageInfo = input.required<PageInfo>();
  protected paginationChanged = output<number>();
  protected sortingChanged = output<Sort>();

  protected items = computed(() => this.dnsFirewallLogs().edges || []);

  onPaginationChanged($event) {
    this.paginationChanged.emit($event);
  }

  sortData($event: Sort) {
    this.sortingChanged.emit($event);
  }
}
